import React, { useState, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router';
import { loginRequest } from '../config/msalConfig';
import { apiService } from '../../api/apiService';
import loginLoader from '../../assets/Loader/loginLoader.json';
import gbslogoimg from '../../assets/images/gbs_loginimg.png'
import {
    Button,
    Typography,
    Box,
    Container,
    CssBaseline,
    ThemeProvider,
    createTheme
} from '@mui/material';
import { grid, styled } from '@mui/system';
import LoginBanner from "../../assets/Bg/loginBanner.png";
import StarLogo from "../../assets/SVGs/logo/Logo.svg";
import AbinBev from "../../assets/SVGs/logo/AbinBev.svg";

const theme = createTheme({
    palette: {
        primary: {
            main: '#000000',
        },
    },
});

const BackgroundImage = styled('div')({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${LoginBanner})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    zIndex: 0,
});

const Logo = styled('img')({
    height: '40px',
    width: 'auto',
    marginRight: theme.spacing(2),
});

const Footer = styled(Box)({
    position: 'absolute',
    bottom: theme.spacing(2),
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 3),
    color: 'rgba(255, 255, 255, 0.8)',
});
const OverLay = styled(Box)({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: '#000000CC',
    borderRadius: '20px',
});

export default function Login() {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async () => {
        setIsLoading(true);
        try {
            // Perform login using redirect instead of popup
            await instance.loginRedirect(loginRequest);
        } catch (error) {
            console.error("Login failed:", error);
            setIsLoading(false);
        }
    };


    const handleRedirectResponse = async () => {
        setIsLoading(true);
        try {
            await instance.initialize(); // Ensure initialization before calling other APIs

            const loginResponse = await instance.handleRedirectPromise();
            if (!loginResponse) {
                return; // No login response, possibly already logged in
            }

            console.log("Login Response:", loginResponse);

            const username = loginResponse.account?.name || ""; // Assuming the actual username is in the 'name' property
            const nameParts = username.split(' ');
            const formattedName = nameParts
                .slice(0, 2)
                .map(part => part.charAt(0).toUpperCase() + part.slice(1))
                .join(' ');

            localStorage.setItem("userName", formattedName);
            localStorage.setItem("userEmail", loginResponse.account?.username || "");
            console.log('User Name:', formattedName);

            const accounts = instance.getAllAccounts();
            if (accounts.length === 0) {
                throw new Error("No accounts found after login.");
            }

            const account = accounts[0];

            const tokenResponse = await instance.acquireTokenSilent({
                ...loginRequest,
                account,
            });

            localStorage.setItem("tokenKey", tokenResponse.accessToken);

            const authToken = localStorage.getItem("tokenKey");
            if (!authToken) {
                throw new Error("Token is missing from localStorage.");
            }

            const roleData = await apiService(
                "/ops/getRole",
                "GET",
                undefined,
                { Authorization: `Bearer ${authToken}` }
              );

              localStorage.setItem("roleKey", roleData.role);
              localStorage.setItem("apiManagement", roleData.management);
              localStorage.setItem("role", roleData.persona); // This is the key we'll use for role-based routing

              // Redirect to home after login
              navigate("/");

              

            // console.log("Management Data:", roleData.management);

            localStorage.setItem("role", roleData.persona);

            navigate("/");
            // window.location.reload();
        } catch (error) {
            console.error("Error handling login redirect:", error);
        } finally {
            setIsLoading(false);
        }
    };


    // Handle redirect response when returning from login
    // useEffect(() => {

    //     handleRedirectResponse();
    // }, [instance]);

    // In your Login component
useEffect(() => {
    const checkAccounts = async () => {
      await instance.initialize();
      const accounts = instance.getAllAccounts();
      
      // Only handle redirect if we're coming back from a login attempt
      if (window.location.hash.includes("code=") || window.location.hash.includes("error=")) {
        await handleRedirectResponse();
      } else if (accounts.length > 0) {
        // If there are accounts but we're not coming from a redirect,
        // it means the user was logged in but came to login page (e.g., after logout)
        // So we should log them out properly
        await instance.logoutRedirect();
      }
    };
  
    checkAccounts();
  }, [instance]);

  

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box sx={{ height: '95vh', position: 'relative', overflow: 'hidden', margin: '20px', display: 'grid', gridTemplateColumns: '60% 40%' }}>
                <Box sx={{ position: 'absolute', top: theme.spacing(3), left: theme.spacing(3), display: 'flex', alignItems: 'center', zIndex: '99' }}>
                    <Logo src={AbinBev} alt="ABInBev Logo" />
                    <Logo src={StarLogo} alt="STAR Logo" />
                </Box>
                <Box>
                    <BackgroundImage
                        sx={{ borderRadius: '20px', width: '60%' }}
                    >
                        <OverLay>
                        </OverLay>
                    </BackgroundImage>
                    <Box>
                        <img src={gbslogoimg} alt="Loading..." style={{ width: '150px', height: 'auto', position: 'absolute', top: '50%', left: '30%', transform: 'translate(-50%, -50%)' }} />
                    </Box>
                    <Footer sx={{
                        width: '60%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        transition: 'justify-content 1s ease-in-out',
                        alignItems: 'center',
                    }}>
                        <Typography variant="body2" sx={{ color: '#fff', marginBottom: '10px' }}>
                            © 2024 Anheuser-Busch InBev. All rights reserved.
                        </Typography>

                        <Box>
                            {/* <Button sx={{ color: '#fff', textTransform: 'none' }} size="small">Help</Button> */}
                            <Button
                                component="a"
                                href="https://anheuserbuschinbev.sharepoint.com/:p:/s/GlobalOperationalExcellenceProgram/ERF81lgdJoxCrbCVTtKnk2sBNhM1LmU7XRlP0vUvJPJP8w?e=8fWct6"
                                target="_blank"
                                variant="contained"

                                sx={{ color: '#fff', textTransform: 'none' }} size="small">Guide</Button>
                        </Box>

                    </Footer>
                </Box>
                <Box sx={{ display: 'grid', placeItems: 'center' }}>
                    <Container>
                        <Box sx={{ my: 4 }}>
                            <Typography variant="h5" component="h1" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
                                Login to your Account
                            </Typography>
                            <Typography variant="body2" align="center" color="text.secondary" paragraph sx={{ color: '#000' }}>
                                See what is going on with your business
                            </Typography>

                            <form style={{ textAlign: 'center' }}>
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    sx={{ mb: 2, textTransform: 'none', width: '400px' }}
                                    onClick={handleLogin}
                                    disabled={isLoading}
                                >


                                    {isLoading ? "Loading..." : "Login with SSO"}
                                </Button>
                            </form>
                        </Box>
                    </Container>
                </Box>
            </Box>
        </ThemeProvider>
    );
}